// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viral-clips-dashboard {
  width: 100%;
  margin-bottom: 2rem;
}

.viral-clips-dashboard h2 {
  font-size: 1.8rem;
  margin-bottom: 1.2rem;
  color: #222;
}

/* Processing Information Dashboard */
.processing-dashboard {
  margin-bottom: 2rem;
  padding: 1.2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.processing-dashboard h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #333;
}

.processing-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.metric-item {
  flex: 1 1 180px;
  min-width: 180px;
}

.metric-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.3rem;
  text-transform: uppercase;
}

.metric-value {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  padding: 0.5rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.clip-category h3 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: #444;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
}

.clips-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 1.2rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.clip-card {
  flex: 0 0 300px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.clip-card.expanded {
  flex: 0 0 400px;
}

.clip-card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* Video container styles */
.video-container {
  margin-bottom: 1rem;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  background-color: #f0f0f0;
}

.video-container video,
.video-loading,
.video-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  color: #333;
  font-size: 0.9rem;
}

.video-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  color: #d32f2f;
  padding: 1rem;
  text-align: center;
}

.video-error a {
  color: #2196f3;
  text-decoration: underline;
  margin-top: 0.5rem;
}

.video-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8rem;
}

.video-placeholder-icon {
  font-size: 2rem;
}

/* Original video section */
.original-video-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}

.original-video-section h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.original-video {
  border-radius: 8px;
}

/* Clip card content */
.clip-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.8rem;
}

.clip-header h4 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: #333;
  flex: 1 1;
}

.viral-score-badge {
  background-color: #3498db;
  color: white;
  border-radius: 999px;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 24px;
}

.clip-caption {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.clip-metadata {
  font-size: 0.8rem;
}

.metadata-row {
  margin-bottom: 0.8rem;
}

.metadata-label {
  font-weight: 600;
  color: #666;
  margin-bottom: 0.3rem;
}

.metadata-content {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.factor-tag, .hashtag-tag {
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  white-space: nowrap;
}

.factor-tag {
  background-color: #e1f5fe;
  color: #0288d1;
}

.hashtag-tag {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.timing-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #777;
  margin-top: 1rem;
  border-top: 1px dashed #eee;
  padding-top: 0.8rem;
}

.time-label {
  font-weight: 600;
  margin-right: 0.2rem;
}

.expanded-content {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.expanded-section {
  margin-bottom: 1rem;
}

.expanded-section h5 {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #444;
}

.hook-list, .prompt-list {
  padding-left: 1.2rem;
  margin: 0;
  font-size: 0.8rem;
  color: #555;
}

.hook-list li, .prompt-list li {
  margin-bottom: 0.5rem;
}

.clip-transcript {
  font-size: 0.8rem;
  line-height: 1.4;
  color: #555;
  background-color: #f9f9f9;
  padding: 0.8rem;
  border-radius: 4px;
  max-height: 120px;
  overflow-y: auto;
} `, "",{"version":3,"sources":["webpack://./src/components/css/ViralClipsDashboardRow.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,sBAAsB;EAC3C,yBAAyB;AAC3B;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".viral-clips-dashboard {\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.viral-clips-dashboard h2 {\n  font-size: 1.8rem;\n  margin-bottom: 1.2rem;\n  color: #222;\n}\n\n/* Processing Information Dashboard */\n.processing-dashboard {\n  margin-bottom: 2rem;\n  padding: 1.2rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.processing-dashboard h3 {\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.processing-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.metric-item {\n  flex: 1 1 180px;\n  min-width: 180px;\n}\n\n.metric-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 0.3rem;\n  text-transform: uppercase;\n}\n\n.metric-value {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #333;\n  padding: 0.5rem;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.clip-category h3 {\n  font-size: 1.4rem;\n  margin-bottom: 1rem;\n  color: #444;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 0.5rem;\n}\n\n.clips-row {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  gap: 1.2rem;\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n}\n\n.clip-card {\n  flex: 0 0 300px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.clip-card.expanded {\n  flex: 0 0 400px;\n}\n\n.clip-card:hover {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n/* Video container styles */\n.video-container {\n  margin-bottom: 1rem;\n  border-radius: 6px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%; /* 16:9 aspect ratio */\n  background-color: #f0f0f0;\n}\n\n.video-container video,\n.video-loading,\n.video-error {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.video-error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #d32f2f;\n  padding: 1rem;\n  text-align: center;\n}\n\n.video-error a {\n  color: #2196f3;\n  text-decoration: underline;\n  margin-top: 0.5rem;\n}\n\n.video-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 0.8rem;\n}\n\n.video-placeholder-icon {\n  font-size: 2rem;\n}\n\n/* Original video section */\n.original-video-section {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #eee;\n}\n\n.original-video-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.original-video {\n  border-radius: 8px;\n}\n\n/* Clip card content */\n.clip-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.8rem;\n}\n\n.clip-header h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  color: #333;\n  flex: 1;\n}\n\n.viral-score-badge {\n  background-color: #3498db;\n  color: white;\n  border-radius: 999px;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 24px;\n}\n\n.clip-caption {\n  font-size: 0.9rem;\n  color: #555;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n}\n\n.clip-metadata {\n  font-size: 0.8rem;\n}\n\n.metadata-row {\n  margin-bottom: 0.8rem;\n}\n\n.metadata-label {\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 0.3rem;\n}\n\n.metadata-content {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.factor-tag, .hashtag-tag {\n  padding: 0.2rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  white-space: nowrap;\n}\n\n.factor-tag {\n  background-color: #e1f5fe;\n  color: #0288d1;\n}\n\n.hashtag-tag {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.timing-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.75rem;\n  color: #777;\n  margin-top: 1rem;\n  border-top: 1px dashed #eee;\n  padding-top: 0.8rem;\n}\n\n.time-label {\n  font-weight: 600;\n  margin-right: 0.2rem;\n}\n\n.expanded-content {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.expanded-section {\n  margin-bottom: 1rem;\n}\n\n.expanded-section h5 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #444;\n}\n\n.hook-list, .prompt-list {\n  padding-left: 1.2rem;\n  margin: 0;\n  font-size: 0.8rem;\n  color: #555;\n}\n\n.hook-list li, .prompt-list li {\n  margin-bottom: 0.5rem;\n}\n\n.clip-transcript {\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: #555;\n  background-color: #f9f9f9;\n  padding: 0.8rem;\n  border-radius: 4px;\n  max-height: 120px;\n  overflow-y: auto;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
